import React from 'react';
import './Service.css';

const Service = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="header-content">
            <i className="fas fa-shield-alt"></i>
            <h1>שירות ואחריות</h1>
          </div>
        </div>
      </div>

      <section className="service-content">
        <div className="container">
          <div className="service-card">
            <h2>באוטוקרוס, אתם בידיים טובות</h2>
            
            <div className="service-features">
              <div className="feature">
                <i className="fas fa-handshake"></i>
                <p>
                  באוטוקרוס יבואני רכב, אנו מעניקים ללקוחותינו שירות V.I.P אישי ומסור – משיחת הטלפון הראשונה ועד הרבה אחרי רכישת הרכב.
                </p>
              </div>

              <div className="feature">
                <i className="fas fa-user-tie"></i>
                <p>
                  אנחנו כאן ללוות אתכם בכל שלב בדרך, כדי להבטיח חוויית קנייה בטוחה, מקצועית ומהנה.
                </p>
              </div>

              <div className="feature">
                <i className="fas fa-shield-alt"></i>
                <p>
                  בהתאם לחוק שירותי הרכב והתחבורה, כל רכב הנרכש ביבוא מקביל זכאי לטיפול ואחריות דרך היבואן הרשמי.
                </p>
              </div>

              <div className="feature">
                <i className="fas fa-star"></i>
                <p>
                  לכן, באוטוקרוס תקבלו אחריות מלאה בהתאם לאחריות היבואן – עם ליווי אישי ודאגה אמיתית לצרכים שלכם.
                </p>
              </div>
            </div>

            <div className="cta-buttons">
              <a href="tel:97233820232" className="cta-button phone-button">
                <i className="fas fa-phone-alt"></i>
                התקשר עכשיו
              </a>
              <a href="https://wa.me/97233820232" target="_blank" rel="noopener noreferrer" className="cta-button whatsapp-button">
                <i className="fab fa-whatsapp"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Service; 